<loading *ngIf="loading" class="full">
    <ng-container i18n="@@addBank.submitLoading">Loading...</ng-container>
</loading>
<div *ngIf="!loading">

    <div *ngIf="error" class="alert alert-warning">{{error}}</div>

    <ng-container [ngSwitch]="template">
        <ng-container *ngSwitchCase="AddBankTemplates.IBAN">
            <bank-iban-form
                (confirm)="onBankDataSubmit($event)"
            ></bank-iban-form>
            <div class="text-center p-3">
                <button class="btn btn-link" (click)="setTemplate(AddBankTemplates.MANUALLY)" i18n="@@addBank.addManually">Add bank details manually</button>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="AddBankTemplates.MANUALLY">
            <bank-details-form
                [data]="data"
                (confirm)="onBankDataSubmit($event)"
            ></bank-details-form>
            <div class="text-center p-3">
                <button *ngIf="isIbanServiceAvailable" class="btn btn-link" (click)="setTemplate(AddBankTemplates.IBAN)" i18n="@@addBank.addAutomatically">Go back to automatic bank adding</button>
            </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <p class="text-gray text-sm" i18n="@@addBank.details.info">Your bank has been added to BitOasis. Please find the details below.</p>
            <bank-details
                *ngIf="!error"
                [data]="data"
                (reject)="removeBank($event)"
                (confirm)="onDetailsSubmit()"
            ></bank-details>
        </ng-container>
    </ng-container>
</div>

<otp-modal
    [show]="showOtpModal"
    [otpType]="OtpRequestType.CREATE_BANK"
    (close)="closeOtpModal()"
    (otpSubmit)="onOtpSubmit($event)"
    buttonLabel="Add a new bank"
    i18n-buttonLabel="@@addBank.title"
></otp-modal>
